import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-strong--sprite",
  "use": "plus-strong--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"plus-strong--sprite\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#2C3638\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.6\">\n        <path d=\"M16.5 9.5v14M9.5 16.5h14\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol